import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable, of } from 'rxjs';

@Injectable()
export class NeverShowRouteResolver implements Resolve<boolean> {
  public resolve(): Observable<boolean> {
    return of(false);
  }
}
